import Token from './token';

/**
 * Creates an Loopable Token
 */
class LoopableToken extends Token {
	constructor( { id, type = 'text', name, cacheable = true, requiresUser = false, options = {}, itemID } ) {
		super( { id, type, name, cacheable, requiresUser, options, itemID } );
	}
}

export default LoopableToken;
